module.exports = __webpack_public_path__ + "frontend/images/favicons/apple-touch-icon.png?eaa2de9955ac7da2f00d02649b392c53";